import { Component, OnInit, Input, Output, OnChanges, ViewChild, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';

import * as _ from 'lodash';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// config
import { navigationConfig } from '../../config/navigation.config';

// Own feature
import { NavigationService } from '../../service/navigation.service';
import {
   navigationStore1stRequestOptions,
   navigationStore2stRequestOptions
} from '../../store/actions';
import { INavRequestOption } from '../../model/nav-request-option.interface';
import { gNavContainer } from '../../compc/nav-cont/nav-cont.component';
import { ConfirmDialogsService } from '../../../core/components/confirm-dialog/service/confirm-dialog.service';
import { LoadingphaseService } from '../../service/loadingphase.service';


@Component({
   selector: 'app-topmenu-nav-search',
   templateUrl: './topmenu-nav-search.component.html',
   styleUrls: ['./topmenu-nav-search.component.scss']
})
export class TopmenuNavSearchComponent implements OnInit, OnChanges {
   // loading data

   public set _loadingPhase(value: boolean) {
      this._loadingphaseService.setContentBlockState(value);
      this._loadingphaseService.setLoadingphase(value, 'nav_graph');
   }

   private _currentLoadingphase: boolean;
   public get _loadingPhase(): boolean {
      return this._currentLoadingphase;
   }

   // input ctrl
   public searchFormInputCtrlValue = '';
   // option ctrl
   public optionCtrlValue = '';
   public optionCtrlGroupPairs: { uiMessage: string, value: string }[] = [];

   // form
   public searchFormVisible = false;
   public searchForm: FormGroup = null;

   // input
   @Input() navGraph1 = true;      // otherwise: navGraph2
   @Input() showNavSearch = false;
   // output
   @Output() searchRequestOptionsOpen = new EventEmitter<boolean>();
   // children
   @ViewChild(MatMenuTrigger) public readonly matMenuTrigger: MatMenuTrigger;

   public arrNavSearchHistory: string[] = [];

   constructor(
      private _store: NgRedux<IAppState>,
      private _navigationService: NavigationService,
      private _messageSnackService: UiMessageSnackService,
      private _confirmDialogService: ConfirmDialogsService,
      private _loadingphaseService: LoadingphaseService,
      private _cdr: ChangeDetectorRef,
   ) { }

   ngOnInit() {
      this._loadingphaseService.subscribeToContentBlockEmitter((state) => this._currentLoadingphase = state);

      // initialize FormGroup
      this.searchForm = new FormGroup({
         searchFormInputCtrl: new FormControl()
      });
   }

   ngOnChanges() {

      // show/hide nav search
      this.searchFormVisible = this.showNavSearch;
   }

   // ---------------------------------------------------------------------------------------------
   // -- ctrl searchInput
   // ---------------------------------------------------------------------------------------------
   public onSubmit() {
      // sanity
      if ((this.searchFormInputCtrlValue).trim() === '' || this._loadingPhase) {
         return;
      }

      this.onNavSearchHistorySelected(this.searchFormInputCtrlValue);
   }

   public onNavSearchHistorySelected(navSearchInputValue: string) {
      this._loadingPhase = true;

      this.searchFormInputCtrlValue = navSearchInputValue;
      // fill search history and shrink
      this.arrNavSearchHistory.unshift(navSearchInputValue);
      if (this.arrNavSearchHistory.length > navigationConfig.navSearchHistroyMaxEntries) {
         this.arrNavSearchHistory = _.slice(this.arrNavSearchHistory, 0, navigationConfig.navSearchHistroyMaxEntries);
      }
      // workaround to detect changes in history and update UI / fix ExpressionChangedAfterItHasBeenCheckedError
      this._cdr.detectChanges();
      // store request Options für
      if (this.navGraph1) {
         // request options
         const requestOptions: INavRequestOption = this._store.getState().navigationState.element1stRequestOptions;

         // merge and save
         this._store.dispatch(navigationStore1stRequestOptions(
            {
               input: navSearchInputValue,
               edges: requestOptions.edges,
               maxnodes: navigationConfig.loadRequestMaxElements,
               loadOptions: 'graph'
            }
         ));

         // -->>ASY
         this._navigationService.loadElements1stInitial()
            .then((boolResultASY: IBoolResult) => {
               // result available
               if (boolResultASY.result) {

                  // show graph view
                  gNavContainer.showGraphView();
                  return;
               }
               this._loadingPhase = false;
               // no data
               this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'TopmenuSearchComponent');
            })
            .catch((err: ErrorMessage) => {
               this._loadingPhase = false;
               this._messageSnackService.showSnackError(err.message, 'TopmenuSearchComponent');
            });

         // Search Graph 2
      } else {
         // request options
         const requestOptions: INavRequestOption = this._store.getState().navigationState.element2stRequestOptions;

         // merge and save
         this._store.dispatch(navigationStore2stRequestOptions(
            {
               input: navSearchInputValue,
               edges: requestOptions.edges,
               maxnodes: navigationConfig.loadRequestMaxElements,
               loadOptions: 'graph'
            }
         ));

         // -->>ASY
         this._navigationService.loadElements2stInitial()
            .then((boolResultASY: IBoolResult) => {

               // result available
               if (boolResultASY.result) {
                  return;
               }
               this._loadingPhase = false;
               // no data
               this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'TopmenuSearchComponent');
            })
            .catch((err: ErrorMessage) => {
               this._loadingPhase = false;
               this._messageSnackService.showSnackError(err.message, 'TopmenuSearchComponent');
            });
      }
   }

   // ---------------------------------------------------------------------------------------------
   // -- Search options handler
   // ---------------------------------------------------------------------------------------------
   public onSearchOptionsCancel() {
      this.searchRequestOptionsOpen.emit(false);
   }
   public onSearchOptionsSubmit() {
      this.searchRequestOptionsOpen.emit(false);
   }
   public onSearchOptionsError(error: ErrorMessage) {
      this.searchRequestOptionsOpen.emit(false);
   }

   public onRequestOptionChanged(requestOptions: INavRequestOption) {
      // sanity
      if (!requestOptions) {
         console.warn('Fehlende parameter für geänderte Request Optionen');
         return;
      }

      // save to store
      if (this.navGraph1) {
         this._store.dispatch(navigationStore1stRequestOptions(requestOptions));
      } else {
         this._store.dispatch(navigationStore2stRequestOptions(requestOptions));
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/topmenu-nav-search/topmenu-nav-search.component.ts